import { recipeFamilyFor } from './recipeFamilies';
import { TOWN_PROP_PALETTE_KEYS, type TownPropTemplate, type TownPropPalette } from '../../../../shared/scene/townPropTemplates';
export { TOWN_PROP_TEMPLATES, resolveTownPropTemplate, resolveTownPropPalette as townPropPalette, shadeTownColor } from '../../../../shared/scene/townPropTemplates';
export type { TownPropTemplate, TownHouseTemplate, TownLanternTemplate, TownPropPalette, TownPropPaletteOverrides, TownPropRenderBand } from '../../../../shared/scene/townPropTemplates';

export function townColorHex(color: number): string {
  return '#' + color.toString(16).padStart(6, '0');
}

/** Cache identity contains every rendered palette value as well as the silhouette. */
export function townTemplateTextureSuffix(template: TownPropTemplate, palette: TownPropPalette): string {
  const family = recipeFamilyFor(template);
  if (family) return family.textureSuffix(template as never, palette);
  const colors = TOWN_PROP_PALETTE_KEYS.map(key => palette[key].toString(16).padStart(6, '0')).join('-');
  return `__tpl_${template}_${colors}`;
}
